// libraries
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Stack, Typography, useTheme } from '@mui/material'

// generic components
import Input from 'components/generic/form/Input'
import Select from 'components/generic/form/Select'
import CustomerAutocomplete from 'components/generic/form/AsyncAutocomplete/CustomerAutocomplete'

// helpers and utils
import { CUSTOMERS_FILTERS, TRANSPORTATION_TYPE_OPTIONS } from 'utils/constants'
import { useGetCustomerQuery } from 'services/customers'
import { clearCarrier } from 'state/customer'

const FreightCostBladeCarrierInformation = ({ disableFields }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const methods = useFormContext()
  const { control, formState, setValue } = methods
  const { errors } = formState
  const { carrier } = useSelector(state => state.customer)
  const { data: carrierData } = useGetCustomerQuery({ customerId: carrier?.id }, { skip: !carrier?.id })

  useEffect(() => {
    if (carrierData) {
      setValue('carrier', carrierData, { shouldDirty: true })
      dispatch(clearCarrier())
    }
  }, [carrierData])

  return (
    <Stack spacing={2}>
      <Typography variant="h6" gutterBottom>
        Carrier Information
      </Typography>
      {disableFields ? (
        <>
          <Input
            name="carrier"
            label="Carrier"
            variant="standard"
            size="small"
            defaultValue=""
            control={control}
            disabled
            sx={{
              'input.Mui-disabled': { WebkitTextFillColor: theme.palette.text.primary },
              'label.Mui-disabled': { WebkitTextFillColor: theme.palette.text.secondary },
            }}
            InputProps={{ disableUnderline: true }}
            InputLabelProps={{ shrink: true }}
          />
          <Input
            name="transportationType"
            label="Transportation Type"
            variant="standard"
            size="small"
            defaultValue=""
            control={control}
            disabled
            sx={{
              'input.Mui-disabled': { WebkitTextFillColor: theme.palette.text.primary },
              'label.Mui-disabled': { WebkitTextFillColor: theme.palette.text.secondary },
            }}
            InputProps={{ disableUnderline: true }}
            InputLabelProps={{ shrink: true }}
          />
        </>
      ) : (
        <>
          <CustomerAutocomplete
            name="carrier"
            label="Carrier"
            variant="outlined"
            size="small"
            defaultValue={null}
            control={control}
            error={!!errors.carrier}
            helperText={errors.carrier?.message}
            fullWidth
            freeSolo={false}
            baseFilter={CUSTOMERS_FILTERS.CARRIER}
            quickAdd
            formControlProps={{ sx: { width: '40%' } }}
            autocompleteProps={{
              renderOption: (props, option) => (
                <li {...props} key={option.id}>
                  {option.displayName}
                </li>
              ),
              isOptionEqualToValue: (option, value) => option?.id === value?.id,
            }}
          />
          <Select
            name="transportationType"
            label="Transportation Type"
            variant="outlined"
            size="small"
            defaultValue=""
            control={control}
            items={TRANSPORTATION_TYPE_OPTIONS}
            sx={{ width: '40%' }}
          />
        </>
      )}
    </Stack>
  )
}

FreightCostBladeCarrierInformation.propTypes = {
  disableFields: PropTypes.bool,
}

FreightCostBladeCarrierInformation.defaultProps = {
  disableFields: false,
}

export default FreightCostBladeCarrierInformation
